import React, { ChangeEvent } from "react";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { Grid, InputAdornment, IconButton } from "@material-ui/core";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrTextField from "../../shared/controls/TrTextField";
import TrSelect from "../../shared/controls/TrSelect";
import { SchoolCarrier } from "../../../models/financing-request/SchoolCarrier";
import { VehicleType } from "../../../models/vehicle-type/VehicleType";
import TrSelectData from "../../../models/shared/TrSelectData";
import SelectItem from "../../../models/shared/SelectItem";
import TrackerName from "../../../models/financing-request/FinancingRequestBasicInfoTrackerName";
import {
  nameof,
  getTooltipForDecimalInput
} from "../../../utilities/utilities";

interface Props {
  index: number;
  schoolCarrier: SchoolCarrier;
  vehicleTypeItems: SelectItem<VehicleType>[];
  validationResult: ValidationResult;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: (e: any) => void;
  onDelete: (index: number) => void;
}

function SchoolCarrierItem({
  index,
  schoolCarrier,
  vehicleTypeItems,
  validationResult,
  onChange,
  onSelectChange,
  onDelete
}: Props) {
  const getVehicleTypeSelectData = () => {
    const selectTypeData: TrSelectData<SelectItem<VehicleType>> = {
      valueProp: "value",
      textProp: "text",
      data: vehicleTypeItems
    };

    return selectTypeData;
  };

  return (
    <Grid container item xs={12} spacing={6} className="noMarginPadding">
      <Grid
        container
        item
        xl={11}
        lg={11}
        spacing={5}
        className="noMarginPadding"
      >
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrSelect
            required
            label="Vrsta vozila"
            name={nameof<typeof schoolCarrier>("vehicleType")}
            value={schoolCarrier.vehicleType}
            className="selectFormControl"
            selectData={getVehicleTypeSelectData()}
            onChange={onSelectChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.SchoolCarriers,
                index.toString(),
                nameof<typeof schoolCarrier>("vehicleType")
              )
            }
          ></TrSelect>
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Registracijske oznake"
            name={nameof<typeof schoolCarrier>("registrationPlate")}
            value={schoolCarrier.registrationPlate || ""}
            className="textField"
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.SchoolCarriers,
                index.toString(),
                nameof<typeof schoolCarrier>("registrationPlate")
              )
            }
          />
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Ukupna dnevna kilometraža"
            name={nameof<typeof schoolCarrier>("dailyMileageTotal")}
            value={schoolCarrier.dailyMileageTotal || ""}
            type="number"
            tooltip={getTooltipForDecimalInput()}
            className="textField"
            InputProps={{
              endAdornment: <InputAdornment position="end">Km</InputAdornment>
            }}
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.SchoolCarriers,
                index.toString(),
                nameof<typeof schoolCarrier>("dailyMileageTotal")
              )
            }
          />
        </Grid>
        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
          <TrTextField
            required
            label="Broj učenika"
            name={nameof<typeof schoolCarrier>("numberOfStudents")}
            value={schoolCarrier.numberOfStudents || ""}
            type="number"
            className="textField"
            onChange={onChange}
            error={
              !validationResult.isArrayPropertyValid(
                TrackerName.SchoolCarriers,
                index.toString(),
                nameof<typeof schoolCarrier>("numberOfStudents")
              )
            }
          />
        </Grid>
      </Grid>
      <Grid item xl={1} lg={1}>
        <IconButton aria-label="delete" onClick={() => onDelete(index)}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

function areEqual(prevProps: Props, nextProps: Props): boolean {
  if (
    prevProps.schoolCarrier === nextProps.schoolCarrier &&
    prevProps.vehicleTypeItems === nextProps.vehicleTypeItems &&
    prevProps.validationResult.getTrackerMessages(TrackerName.SchoolCarriers)
      .length ===
      nextProps.validationResult.getTrackerMessages(TrackerName.SchoolCarriers)
        .length
  ) {
    return true;
  }
  return false;
}

// Export as memoized component (performance boost)
export default React.memo(SchoolCarrierItem, areEqual);
